// extracted by mini-css-extract-plugin
export default {"container":"xs8S37","header":"X7hYoQ","content":"hocgRE","passengerName":"TiBVDU","pnrNumber":"jIQx0N","container--mobile":"Nky0iV"};